import {Component, forwardRef, Inject, Injector} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {JSonSerializer} from '../../model/JSonSerializer';
import {EmployeeForScheduling, EmployeeInfo, EmployeeSchedule} from '../../model/schedule.model';
import {AlertService} from '../../services/alert.service';
import {ClientService} from '../../services/client.service';
import {SessionService} from '../../services/session.service';
import {DlgEditEmployeeScheduleComponent} from './DlgEditEmployeeScheduleComponent';
import {DlgEmployeeScheduleComponent} from './DlgEmployeeScheduleComponent';
import {DayType, ModalResult, SexType} from "../../model/common.model";
import {DlgAskYesNoQuestion} from "../../common/DlgAskYesNoQuestion";
import {WeeklyWorkShift} from "./model/WeeklyWorkShift";
import {DlgErrorMessage} from "../../common/DlgErrorMessage";
import {CustomCellComponent} from "../schedulePerEmployee/common/CustomCellComponent";
import {DomSanitizer} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {WorkShiftBonus} from "../bonus/model/WorkShiftBonus";

@Component({
  templateUrl: './WorkShiftCellComponent.html'
})

export class WorkShiftCellComponent extends CustomCellComponent{

  protected model: WeeklyWorkShift;


  constructor (private injector: Injector,
               @Inject(forwardRef(() => AlertService)) protected alertService: AlertService,
               @Inject(forwardRef(() => ClientService)) protected clientService: ClientService,
               @Inject(forwardRef(() => DomSanitizer)) protected domSanitizer: DomSanitizer,
               @Inject(forwardRef(() => NgbModal)) protected modalService: NgbModal,
               @Inject(forwardRef(() => Router)) private router: Router,
               @Inject(forwardRef(() => SessionService)) protected session: SessionService,
               @Inject(forwardRef(() => TranslateService)) protected translate: TranslateService
  ) {
    super(alertService,clientService,domSanitizer, modalService, session, translate);
    // this.refDate = this.injector.get('date');
    // this.weeklyWorkShiftComponent = this.injector.get('weeklyWorkShiftComponent');
    // this.schedules = this.injector.get('schedules');
    this.model = this.injector.get('model');
    this.dayType = this.injector.get('dayType');
    this.container = this.injector.get('container');
    this._init();
  }


  private _init(){
    this.schedules = this.model.schedulesByDay(this.dayType);
    this.refDate = this.model.getRefDate(this.dayType);
    if (this.container.addCellComponent(this.dayType, this)){
      // console.log('Adding CellComponent for: ' + this.dayType + ' ' + this.componentId);
    }else{
      console.log('Can\'t add CellComponent for: ' + this.dayType  + ' ' + this.componentId);
    }
//    console.log('init');
    this.validateForErrors();
  }


  public isMale(bean: EmployeeInfo): boolean {
    if (SexType.FEMALE === bean.sex) {
      return false;
    }
    return true;
  }


  onItemDrop( e: any) {
    // console.log('Information dropped: '  + JSON.stringify(e.dragData, null, 2));
    const schedules = <EmployeeSchedule[]> e.dragData;
    const toAdd = new Array<EmployeeSchedule>();
    const workShiftBonusesToAdd = new Array<WorkShiftBonus>();
    const job = this.model.jobAndUnitInfo.job;
    const unit = this.model.jobAndUnitInfo.unit;
    // const jobId = job.jobId;
    // const unitId = unit.unitCode;
    for ( const bean of schedules ) {
      if (this.model.jobUnitAndEmployeeManager.exists(job.jobId, unit.unitCode, bean.employee.id)){
        const es = bean.clone();
        es.id =  -1 * moment().unix();
        // es.id = -1 * Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
        es.employeeId = bean.employee.id;

        const jobUnitAndEmployee = this.model.jobUnitAndEmployeeManager.retrieveByKey(job.jobId,unit.unitCode,bean.employee.id);
        if (jobUnitAndEmployee.hasColor){
          es.sdDefaultBg = jobUnitAndEmployee.bg;
        }

        es.unitId = unit.unitCode;
        es.jobId = job.jobId;
        es.refDate = this.refDate;
        es.active = false;
        toAdd.push(es);

        if (this.session.useShiftBonus()) {
          this.model.workShiftBonusManager.debug();
          const copied = this.model.workShiftBonusManager.copyWorkShiftBonusFromSchedule(bean.id, es.id, es.refDate);
          for (const copy of copied) {
            this.model.workShiftBonusManager.add(copy);
          }
          console.log('After copy');
          this.model.workShiftBonusManager.debug();
        }
        /*
        if (this.model.workShiftBonusManager.getWorkShiftBonusPerScheduleId(bean.id)){
          for (const workShiftBonus of this.model.workShiftBonusManager.getWorkShiftBonusPerScheduleId(bean.id)){
            const tmp = workShiftBonus.clone();
            tmp.resetId();
            tmp.workShiftId = es.id;
            workShiftBonusesToAdd.push(tmp);
          }
        }

         */


      }else{
        console.log('Employee: ' + bean.employee.fullName + ' has no job: ' + job.description + '('+ job.jobId  +')' + ' in unit: ' + unit.description + ' ( '+unit.unitCode+' )');

        const modalRef = this.modalService.open(DlgErrorMessage);
        this.alertService.registerModal(modalRef);

        modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('EmployeeHasNotThisJob',{employee:bean.employee.fullName, job: job.description, unit: unit.description}));
        modalRef.result.then((result) => {
          // console.log( 'Closed with: ' + JSON.stringify(result,null, 2));
          this.validateForErrors();
        }, (reason) => {
          console.log(`Dismissed ${this.getDismissReason(reason)}`);
        });
      }
    }
    super.addAfterDrop(toAdd);

  }

  public hasPlannedSchedules(): boolean {
    return this.model.hasPlanningForDayOfWeek(DayType.retrieveFromDate(this.refDate));
  }

  public onAddEmployeeSchedule() {
    console.log('Adding Employee');
    console.log(' workshift: ' + this.model.jobAndUnitInfo.fullDescription);

    this.loading = true;

    const ref = moment(this.refDate);

    const refDatesOfTheWeek = new Array<moment.Moment>();

    for (const dt of this.model.refDates){
      refDatesOfTheWeek.push(moment(dt).startOf('day'));
    }

    // const startOfWeek =  moment(refDatesOfTheWeek[0]).startOf('day');
    // const endOfWeek = moment(refDatesOfTheWeek[refDatesOfTheWeek.length-1]).endOf('day');

    const shiftStart = moment(this.model.startTime);
    const shiftEnd = moment(this.model.endTime);

    this.clientService.retrieveEmployeesForScheduling(this.model.jobAndUnitInfo.job.jobId, refDatesOfTheWeek, shiftStart, shiftEnd).then(
      (res) => {
        if (res.success) {
          console.log(' Retrieved retrieveEmployeesForScheduling',res.data);

          const serializer = new JSonSerializer();
          const data = serializer.deserializeArray(res.data, (bean: any) => {
            return new EmployeeForScheduling();
          });
          this._chooseEmployee(data);
        } else {
          console.log('Cant logging ' + res.description);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );

  }


  private _chooseEmployee(beans: EmployeeForScheduling[] ) {

    const modalRef = this.modalService.open(DlgEmployeeScheduleComponent, {size: 'lg'});
    this.alertService.registerModal(modalRef);

    const alreadyScheduled = new Array<EmployeeSchedule>();


    for (const bean of beans){
      // This is retrieving scheduled saved in the system (DB) and are not visible in the current UI (aka selection of units is smaller)
      alreadyScheduled.push(...this.model.otherScheduleManager.retrieveAllSchedules(bean.employee.id));
      // Retrieve the schedules for employees that could be in a line visible in the UI.
      alreadyScheduled.push(...this.session.weeklyWorkshiftManager.retrieveSchedulesForEmployeeNotInTheCurrentWeeklyWorkShift(bean.employee.id, this.model));
      //March 7th 2018: Retrieve from
      alreadyScheduled.push(...bean.schedules);
    }

    console.log('Already loaded: ',alreadyScheduled);

    // const schedules = this.session.otherScheduleManager.retrieveSchedules();


    // modalRef.componentInstance.populate(beans, this.weeklyWorkShiftComponent.model, this.schedules);
    modalRef.componentInstance.populate(beans, this.model, alreadyScheduled);

    // modalRef.componentInstance.employeeForSchedulings = beans;

    modalRef.result.then((result) => {
      console.log( 'Closed with: ' ,result);

      if (result) {
        if (ModalResult.OTHER === result){
          const jobId = this.model.jobAndUnitInfo.job.jobId;
          const unitId = this.model.jobAndUnitInfo.unit.unitCode;
          const note = this.translate.instant('MissingWorkShift');
          this.sendRequestForWorkshift(this.model.startTime,this.model.endTime,jobId,unitId,note);
        }else{
          const beans = <EmployeeSchedule[]> result;
          for (const schedule of beans){
            // delete schedule.meal1;
            // delete schedule.meal2;

            this.model.add(schedule);
          }
        }
      }
      //
      this.validateForErrors();
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }


  onViewEmployee(id: string) {
    // this.session.sharedParams.employeeId = id;
    this.router.navigate([this.session.homePath + '/employees'],{queryParams:{'id': id}});
  }



  public onDeleteEmployeeSchedule( bean: EmployeeSchedule) {


    const modalRef = this.modalService.open(DlgAskYesNoQuestion);
    modalRef.componentInstance.populate(this.translate.instant('QuestionTitle'),this.translate.instant('DoYouReallyWantToDelete'));
    modalRef.result.then((result) => {
      console.log('Result: ' + result);
      if (ModalResult.YES === result){
        // Deleting...
        if (this.model.delete(bean)) {
          console.log('Deleted employee');
          this.validateForErrors();
        }
      }
    }, (reason) => {
      // console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }

  public onEditEmployeeSchedule( bean: EmployeeSchedule ) {
    if (!bean) {
      console.log('Cant editEmployeeSchedule because it is null!');
      return;
    }

    const modalRef = this.modalService.open(DlgEditEmployeeScheduleComponent);
    modalRef.componentInstance.populate(bean);

    modalRef.result.then((result) => {
      console.log( `Closed with: ${result}`);
      this.validateForErrors();
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }

  public explainScheduleDefault(bean:EmployeeSchedule):string{
    return bean.employee.shortName;
  }





}
